import template from "./user-entity-association.html";
import "./user-entity-association.less";
import { EVENT_LOGOUT } from "../../../../constants";
import { FORM_ENTITY_DETAILS } from "routes.js";
import { pluralize } from "humanize-plus";

//user-modal
export function controller(eventBus, $scope, appState, api, $logger) {
	const ctrl = this;

	ctrl.handleClose = handleClose;
	ctrl.handleCancel = handleCancel;
	ctrl.$onInit = onInit;
	ctrl.$onDestroy = handleClose;
	ctrl.addAllLicenses = "true";
	ctrl.handleDeselectDetails = handleDeselectDetails;
	ctrl.primaryPluralNomenclature = pluralize(2, ctrl.resolve.entityConfig.Primary?.Type?.Name).toLowerCase();

	function onInit() {
		ctrl.friendlyEntity = ctrl.resolve.entity;
		eventBus.register(
			EVENT_LOGOUT,
			() => {
				handleCancel();
			},
			$scope
		);

		loadEntityDetails();
	}

	function loadEntityDetails() {
		const route = FORM_ENTITY_DETAILS(appState.forms.selected.Id, ctrl.resolve.entity.Id);

		api.get(route).then((entityDetail) => {
			ctrl.entityDetail = entityDetail.filter((d) => 
				d.Entity.Type.Code === ctrl.resolve.entityConfig.Primary?.Type.Code && d.Type.Code === ctrl.resolve.entityConfig.RelationshipType.Code
			);
			ctrl.entityDetail.map((e) => (e.isSelected = true));
		});
	}

	function handleDeselectDetails() {
		ctrl.entityDetail = ctrl.entityDetail.map((entity) => ({ ...entity, isSelected: false }));
	}

	function handleClose() {
		if(ctrl.addAllLicenses === "true") {
			ctrl.modalInstance.close([ctrl.resolve.entity]);
		} else {
			const licensesToAdd = ctrl.entityDetail.filter((e) => e.isSelected === true).map((e) => e.Entity);
			ctrl.modalInstance.close(licensesToAdd);
		}
	}

	function handleCancel() {
		ctrl.modalInstance.dismiss();
	}
}

export default angular.module("vesl.components.user-friendly-association", []).component("userFriendlyAssociation", {
	controller,
	template,
	bindings: {
		close: "&",
		dismiss: "&",
		modalInstance: "<",
		resolve: "<"
	}
}).name;
